export default __webpack_public_path__ + "static/media/Bugatti.6b8426d2.png";